import { TableCell } from "@mui/material";
import { colors } from "assets/colors/colors";
import { Typography } from "components/Common/Typography/Typography";

export const BrandTableHeaderCell = ({ column }) => {
  return (
    <TableCell
      key={column.dataKey}
      variant="head"
      style={{ width: column.width, verticalAlign: "top" }}
      align={column.align || "left"}
      sx={{ backgroundColor: "background.paper" }}
    >
      {column.header != null ? (
        column.header
      ) : (
        <Typography text={column.label} variant="p" color={colors.core70} />
      )}
      {column.description && (
        <div>
          <Typography
            text={column.description}
            variant="h5"
            color={colors.core50}
          />
        </div>
      )}
    </TableCell>
  );
};
